import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IoMdClose } from 'react-icons/io';
import pregnancyShapeBg from 'assets/images/program-bg.webp';

import Modal from 'components/Modal';
import SolidButton from 'components/SolidButton';

const modalProps = {
  content: {
    width: '100%',
    maxWidth: 420,
    padding: 0,
    borderRadius: '24px 24px 0 0',
    top: 'auto',
    bottom: 0,
    left: 0,
    right: 0,
    margin: '0 auto',
    transform: 'none',
  },
};

const ExitOfferModal = ({ modalIsOpen, onAcceptFreeTier, onDismiss }) => {
  const { t } = useTranslation();

  return (
    <Modal
      closeOnOverlayClick={false}
      closeOnEsc={false}
      modalProps={modalProps}
      modalIsOpen={modalIsOpen}
      closeModal={onDismiss}
      closeable={false}
    >
      <section className="exit-offer">
        <button type="button" className="exit-offer__close" onClick={onDismiss} aria-label={t('evieApp.leaveFreeTrial.dismiss')}>
          <IoMdClose />
        </button>
        <div className="exit-offer__header">
          <img src={pregnancyShapeBg} alt="silhouette of pregnant woman" className="exit-offer__pregnancy_img" />
        </div>
        <p className="exit-offer__title">{t('evieApp.leaveFreeTrial.title')}</p>
        <p className="exit-offer__content">{t('evieApp.leaveFreeTrial.content')}</p>
        <div className="exit-offer__actions">
          <SolidButton className="evie-primary" onClick={onAcceptFreeTier}>
            {t('evieApp.leaveFreeTrial.accept')}
          </SolidButton>
        </div>
      </section>
    </Modal>
  );
};

ExitOfferModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  onAcceptFreeTier: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default ExitOfferModal;
